import {
  bigCommerceSettingsService,
  type BigCommerceSettings,
} from "@/app/services/generated/bigcommercesettingsService";
import { EnumIntegrationStatus } from "../types";
import type { IntegrationMeta } from "../composables/types";
import messages from "@/plugins/i18n";
import img from "@/assets/images/app/integrations/big_commerce.png";
import { integrationsMenu } from "@/app/ui/navigation/integrationsMenu";
import type BmTabItem from "@/components/controls/tabs/BmTabItem";
import {
  BigCommerceOrderFilter,
  bigCommerceOrderService,
} from "@/app/services/generated/bigcommerceorderService";
import type { LocalDate } from "@js-joda/core";
import { fillFilterDates } from "@/store/modules/integrationErrorStore";

export type BigCommerceLinkStatus = {
  settings: BigCommerceSettings;
  canConnect: boolean;
  status: EnumIntegrationStatus;
};

export async function getBigCommerceLinkStatus(): Promise<BigCommerceLinkStatus> {
  const settings = await bigCommerceSettingsService.getBigCommerceSettings();

  let status = EnumIntegrationStatus.inactive;
  let canConnect = false;

  if (settings.accessToken !== "" && settings.storeHash !== "") {
    canConnect = await bigCommerceSettingsService.testBigCommerceConnection();

    status = canConnect
      ? EnumIntegrationStatus.active
      : EnumIntegrationStatus.unauthenticated;
  }

  return {
    settings,
    canConnect,
    status,
  };
}

export function bigCommerceMeta(
  linkStatus: BigCommerceLinkStatus | null
): IntegrationMeta {
  const status = linkStatus?.status ?? EnumIntegrationStatus.inactive;
  return {
    name: messages.big_commerce_title,
    description: messages.big_commerce_description,
    longDescription: messages.big_commerce_description,
    integrationRoute: status.isInactive()
      ? integrationsMenu.bigCommerce.viewIntroduction()
      : integrationsMenu.bigCommerce.viewOverview(),
    miniImg: img,
    img,
    activated: linkStatus?.status.isActive() ?? false,
    status: status,
  };
}

export function bigCommerceTabs(): BmTabItem[] {
  return [
    {
      label: messages.integrations_overview,
      route: integrationsMenu.bigCommerce.viewOverview(),
    },
    {
      label: messages.integrations_settings,
      route: integrationsMenu.bigCommerce.viewSettings(),
    },
  ];
}

export async function getBigCommerceOrders(
  fromDate: LocalDate,
  toDate?: LocalDate
) {
  return (
    await bigCommerceOrderService.getBigCommerceOrdersByFilter(
      fillFilterDates(new BigCommerceOrderFilter(), fromDate, toDate)
    )
  ).bigCommerceOrders;
}
